"use client";
/*
 * Documentation:
 * DC_Divider — https://app.subframe.com/4f62853ee923/library?component=DC_Divider_5a0813e9-895e-4ac1-ace9-903783a84bca
 */

import React from "react";
import * as SubframeUtils from "../utils";

interface Dc_DividerRootProps extends React.HTMLAttributes<HTMLDivElement> {
  className?: string;
}

const Dc_DividerRoot = React.forwardRef<HTMLDivElement, Dc_DividerRootProps>(
  function Dc_DividerRoot(
    { className, ...otherProps }: Dc_DividerRootProps,
    ref
  ) {
    return (
      <div
        className={SubframeUtils.twClassNames(
          "flex h-px w-full flex-col items-center gap-2 bg-neutral-200",
          className
        )}
        ref={ref}
        {...otherProps}
      />
    );
  }
);

export const Dc_Divider = Dc_DividerRoot;
